import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  notificacoes: [],
  notificacoesNaoLidas: [],
  atividadesNotificacoes: [],
  atualizaNotificacoesAuto: true
};

const getters = {
  // Notificação
  notificacoes: state => state.notificacoes,
  atividadesNotificacoes: state => state.atividadesNotificacoes,
  countNotificacoesNaoLidas: state => state.notificacoesNaoLidas.length,
  atualizaNotificacoesAuto: state => state.atualizaNotificacoesAuto,
};

const actions = {
  // Notificação
  async fetchNotificacoesNaoLidas({ commit }, idColaborador) {
    const response = await axios.get(`${baseUrl}/notificacoes/${idColaborador}?status=P`);

    if (response.data.length) {
      commit('setNotificacoesNaoLidas', response.data);
    } else {
      commit('setNotificacoesNaoLidas', []);
    }
  },

  async fetchNotificacoesPorStatus({ commit }, { status, idColaborador, dtInicial, dtFinal }) {
    try {
      let response;
      if (dtInicial, dtFinal) {
        response = await axios.get(`${baseUrl}/notificacoes/${idColaborador}?status=${status}&dataInicio=${dtInicial}&dataFinal=${dtFinal}`);
      } else {
        response = await axios.get(`${baseUrl}/notificacoes/${idColaborador}?status=${status}`);
      }
      commit('setNotificacoes', response.data);
    } catch (error) {
      console.log(error);
      commit('setNotificacoes', []);
    }
  },
  async marcaNotificacaoLida({ commit }, notificacao) {
    try {
      await axios.put(`${baseUrl}/notificacoes`, notificacao)
      commit('marcaLida', notificacao);
    } catch (error) {
      console.log(error);
    }
  },
  loadConfigNotificacoes({ commit }) {
    commit('loadConfigNotificacoes');
  },
  setAtualizaNotificacoesAuto({ commit }, obj) {
    commit('setAtualizaNotificacoesAuto', obj);
  }
};

const mutations = {
  // Notificação
  setNotificacoes: (state, notificacoes) => state.notificacoes = notificacoes,
  setNotificacoesNaoLidas: (state, notificacoes) => state.notificacoesNaoLidas = notificacoes,
  setAtividadesNotificacoes: (state, notificacoes) => state.atividadesNotificacoes = notificacoes,
  marcaLida: (state, notificacaoLida) => {
    const index = state.notificacoes.findIndex(n => notificacaoLida.IdNotificacao);
    if (index != -1) {
      state.notificacoes = state.notificacoes.filter(n => n.IdNotificacao != notificacaoLida.IdNotificacao);
    }
  },
  loadConfigNotificacoes: state => {
    const config = localStorage.getItem('atualizaNotificacoesAuto');
    if (config) state.atualizaNotificacoesAuto = JSON.parse(config);
  },
  setAtualizaNotificacoesAuto: (state, obj) => {
    localStorage.setItem('atualizaNotificacoesAuto', obj);
    state.atualizaNotificacoesAuto = obj;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}